import { convertNumber } from '@/lib/utils'
import { ProductVoucher } from '@/types/product-detail'
import { VoucherResponse } from '@/types/voucher'

export class VoucherFormatter {
  /**
   * Transforms the voucher API response to the format expected by the ProductInfoVouchers component
   */
  static transformVouchersResponse(
    data?: VoucherResponse | null
  ): ProductVoucher[] {
    if (!data || !data.list_discount || !Array.isArray(data.list_discount)) {
      return []
    }

    return data.list_discount.map((voucher) => ({
      code: voucher.title,
      discount:
        voucher.discount_type === 'percentage'
          ? `${voucher.discount_value}%`
          : `${convertNumber(voucher.discount_value)}`,
      description: voucher.description || '',
      quantity: Math.floor(Math.random() * (100 - 20 + 1)) + 20,
    }))
  }
}
